import React from "react";

export function Screen2CardTitle({ title }: { title?: string }) {
  if (!title) return null;
  return (
    <div style={{ padding: "10px 14px 6px", fontSize: "13px", fontWeight: 600, color: "#333", backgroundColor: "#fff" }}>
      {title}
    </div>
  );
}

export function Screen2CardMemo({ memo }: { memo?: string }) {
  if (!memo) return null;
  return (
    <div style={{ padding: "10px 14px 14px", fontSize: "14px", lineHeight: 1.5, color: "#666", backgroundColor: "#fff", whiteSpace: "pre-wrap" }}>
      {memo}
    </div>
  );
}

export function Screen2Video({ videoId }: { videoId: string }) {
  const [showAnimation, setShowAnimation] = React.useState(true);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setShowAnimation(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ width: "100%", flexShrink: 1, flexGrow: 1, marginTop: 0 }}>
      <style>{`
        @keyframes screen2WhiteFlash {
          0%, 100% { border-color: rgba(200, 230, 255, 1); box-shadow: 0 0 8px rgba(100, 180, 255, 0.9); }
          50% { border-color: rgba(120, 190, 255, 1); box-shadow: 0 0 18px rgba(120, 190, 255, 1); }
        }
      `}</style>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "auto",
          aspectRatio: "16 / 9",
          border: showAnimation && isLoaded ? "4px solid rgba(200, 230, 255, 1)" : "none",
          borderRadius: "4px",
          overflow: "hidden",
          backgroundColor: "transparent",
          animation: showAnimation && isLoaded ? "screen2WhiteFlash 1s ease-in-out infinite" : "none",
        }}
      >
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=0&mute=1&fs=1`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          onLoad={() => setIsLoaded(true)}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            display: "block",
            borderRadius: "12px",
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 0.3s ease",
          }}
        />
      </div>
    </div>
  );
}
